const { services, jwtCookieName, refreshTokenCookieName, headerSentryLogging, sentryLogging, sentryEnvironment } = window.env

export const HOME_LINK: string = process.env.HOME_LINK
export const BRIEF_BUILDER_LINK: string = process.env.BRIEF_BUILDER_LINK
export const EVENT_HUB_LINK: string = process.env.EVENT_HUB_LINK
export const HEADER_DEMO_LINK: string = process.env.HEADER_DEMO_LINK
export const HELP_LINK: string = process.env.HELP_LINK
export const HOST_LEADS_LINK: string = process.env.HOST_LEADS_LINK
export const HOST_READYMAG_LINK: string = process.env.HOST_READYMAG_LINK
export const HOST_ADMIN_LINK: string = process.env.HOST_ADMIN_LINK
export const HOST_SPACES_LINK: string = process.env.HOST_SPACES_LINK
export const LOGIN_LINK: string = process.env.LOGIN_LINK
export const SMART_BOOK_EVENTS_LINK: string = process.env.SMART_BOOK_EVENTS_LINK
export const SMART_BOOK_RESPONSE_LINK: string = process.env.SMART_BOOK_RESPONSE_LINK
export const SMART_BOOK_INSIGHTS_LINK: string = process.env.SMART_BOOK_INSIGHTS_LINK
export const HOST_HOME_LINK: string = process.env.HOST_HOME_LINK
export const HOST_TASKS_SERVICE: string = process.env.HOST_TASKS_SERVICE
export const SMART_BOOK_HOME_LINK: string = SMART_BOOK_RESPONSE_LINK + '/opportunities'

export const LOGGING: boolean = Boolean(headerSentryLogging)
export const APP_SENTRY_LOGGING: boolean = Boolean(sentryLogging)
export const SENTRY_SERVICE: string = services.sentryDSN
export const SENTRY_ENV: string = sentryEnvironment
export const AUTH_SERVICE: string = process.env.AUTH_SERVICE
export const REFRESH_TOKEN_COOKIE_NAME: string = refreshTokenCookieName
export const JWT_COOKIE_NAME: string = jwtCookieName
export const ROOT: string = process.env.HOME_LINK
export const SELF_SERVE_SERVICE: string = process.env.SELF_SERVE_SERVICE
export const BREAKPOINTS: { [key: string]: number } = {
  S: 600,
  M: 900,
  L: 1200
}
export const NODE_ENV: string = process.env.NODE_ENV
